import { useEventListener } from '@vueuse/core';
import { MaybeRef, get } from '@vueuse/shared';

/**
 * Prevents closing the window in the `preventClose` is true, and then calls the provided
 * callback
 */
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const usePreventWindowClose = (preventClose: MaybeRef<boolean>, onClosePrevented = () => {}): void => {
	// eslint-disable-next-line consistent-return
	useEventListener('beforeunload', (e) => {
		if (get(preventClose)) {
			e.preventDefault();
			e.returnValue = '';
			setTimeout(onClosePrevented, 0);
			return '';
		}
	});
};
